import { Transform } from "class-transformer";
import { toEuros } from "@/utils/numberUtils";

export class ValuationTotalDto {
  @Transform(({ value }) => toEuros(value))
  executedAmount = 0;
}
